<template>
  <div id="TopMenu">
    <div
      class="dropdown-menu animated zoomIn show"
      style="margin-top: 70px; overflow: auto; height: 800px; width: 300px"
    >
      <el-menu :default-active="ActiveMenuIndex" class="el-menu-vertical-demo">
        <el-menu-item index="mainPage" class="menu-item" v-on:click="margin">
          <i class="el-icon-menu"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="bscpage1" class="menu-item" v-on:click="bscpage1">
          <i class="el-icon-menu"></i>
          <span slot="title">BU健康度</span>
        </el-menu-item>
        <el-menu-item index="bscpage2" class="menu-item" v-on:click="bscpage2">
          <i class="el-icon-menu"></i>
          <span slot="title">工厂健康度</span>
        </el-menu-item>
        <el-submenu index="3" class="menu-item">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span>能耗日历</span>
          </template>
          <el-menu-item
            index="EnergyCalendar"
            class="menu-item"
            v-on:click="EnergyCalendar"
          >
            <i class="el-icon-menu"></i>
            <span slot="title">能耗日历</span>
          </el-menu-item>
          <el-menu-item
            index="photovoltaic"
            class="menu-item"
            v-on:click="Photovoltaic"
          >
            <i class="el-icon-menu"></i>
            <span slot="title">光伏电站数据</span>
          </el-menu-item>
        </el-submenu>
        <el-submenu index="4" class="menu-item">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span>能源对标平台</span>
          </template>
          <el-menu-item index="InjMold" class="menu-item" v-on:click="InjMold">
            <i class="el-icon-menu"></i>
            <span slot="title">注塑机</span>
          </el-menu-item>
          <!-- <el-menu-item index="Foaming" class="menu-item" v-on:click="Foaming">
            <i class="el-icon-menu"></i>
            <span slot="title">发泡机</span>
          </el-menu-item>
          <el-menu-item
            index="AirCompressor"
            class="menu-item"
            v-on:click="AirCompressor"
          >
            <i class="el-icon-menu"></i>
            <span slot="title">空压机</span>
          </el-menu-item> -->
          <!--  <el-menu-item index="plasticining" class="menu-item" v-on:click="plasticining">
            <i class="el-icon-menu"></i>
            <span slot="title">搪塑线</span> 
          </el-menu-item>  -->
        </el-submenu>
        <el-submenu index="5.2" class="menu-item">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span>生产工艺能耗</span>
          </template>
          <el-menu-item
            index="OperEnergy"
            class="menu-item"
            v-on:click="OperEnergy"
          >
            <i class="el-icon-view"></i>
            <span slot="title">浏览</span>
          </el-menu-item>
          <el-menu-item
            index="OperRouteDesigner"
            class="menu-item"
            v-on:click="OperRouteDesigner"
          >
            <i class="el-icon-cpu"></i>
            <span slot="title">设计</span>
          </el-menu-item>
        </el-submenu>
        <!-- <el-submenu index="5" class="menu-item">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span>最佳实践案例</span>
          </template>
          <el-menu-item index="md" class="menu-item" v-on:click="md">
            <i class="el-icon-menu"></i>
            <span slot="title">金桥MD监控</span>
          </el-menu-item>
          <el-menu-item
            index="transformer"
            class="menu-item"
            v-on:click="transformer"
          >
            <i class="el-icon-menu"></i>
            <span slot="title">金桥变压器经济运行</span>
          </el-menu-item>
          <el-menu-item
            index="PartsEnergy"
            class="menu-item"
            v-on:click="PartsEnergy"
          >
            <i class="el-icon-menu"></i>
            <span slot="title">零件能耗计划</span>
          </el-menu-item>
        </el-submenu> -->
        <el-submenu index="6" class="menu-item">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span>基础数据</span>
          </template>
          <el-menu-item
            index="EnergyPrice"
            class="menu-item"
            v-on:click="EnergyPrice"
          >
            <i class="el-icon-set-up"></i>
            <span slot="title">能耗单价</span>
          </el-menu-item>
          <el-menu-item
            index="EnergyPerImport"
            class="menu-item"
            v-on:click="EnergyPerImport"
          >
            <i class="el-icon-set-up"></i>
            <span slot="title">导入设备单耗</span>
          </el-menu-item>
          <el-menu-item
            index="EnergyCast"
            class="menu-item"
            v-on:click="GoToRoute('/EnergyCast')"
          >
            <i class="el-icon-set-up"></i>
            <span slot="title">能源转换系数</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopMenu",
  props: ["ActiveMenuIndex"],
  methods: {
    GoToRoute(route) {
      this.$router.push(route);
    },
    margin() {
      this.$router.push("/mainPage");
    },
    md() {
      //this.$router.push('/MD');
      window.open("http://172.28.130.32:88/PlantAPP/MDMonitor/Edit");
    },
    svg() {
      this.$router.push("/MeterSVG");
    },
    bscpage1() {
      this.$router.push("/bscpage1");
    },
    bscpage2() {
      this.$router.push("/bscpage2");
    },
    emp1() {
      this.$router.push("/emp1");
    },
    emp2() {
      this.$router.push("/InjMold");
    },
    InjMold() {
      this.$router.push("/InjMold");
    },
    AirCompressor() {
      this.$router.push("/AirCompressor");
    },
    plasticining() {
      this.$router.push("/plasticining");
    },
    Foaming() {
      this.$router.push("/Foaming");
    },
    OperEnergy() {
      this.$router.push("/OperEnergyViewer");
    },
    OperRouteDesigner() {
      this.$router.push("/OperRouteDesigner");
    },
    EnergyPerImport() {
      this.$router.push("/EnergyPerImport");
    },
    EnergyPrice() {
      this.$router.push("/EnergyPrice");
    },
    transformer() {
      this.$router.push("/transformer");
    },
    PartsEnergy() {
      this.$router.push("/PartsEnergy");
    },
    EnergyCalendar() {
      this.$router.push("/EnergyCalendar");
    },
    Photovoltaic(){
      this.$router.push("/photovoltaic");
    }
  }
};
</script>

<style lang="less">
#TopMenu {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  .dropdown-menu {
    position: absolute;
    float: none;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: none;
    float: left;
    min-width: 10rem;
    padding: 0.5rem 0;
    margin: 0.125rem 0 0;
    font-size: 1rem;
    color: #000;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0);
    border-radius: 0.25rem;
  }
  .show {
    display: block;
  }
  .animated {
    animation-duration: 0.5s;
  }
  .zoomIn {
    animation-name: zoomIn;
    animation-fill-mode: both;
  }
  .sidebar-nav {
    padding: 0;
  }
  .menu-item {
    font-size: 16px;
  }
}
</style>
